module.exports = function (title) {
  return '<h5>' + title + '</h5>';
};



//////////////////
// WEBPACK FOOTER
// ./src/js/util/header.js
// module id = 837
// module chunks = 0